module.exports = __webpack_public_path__ + "media/images/foodplaceholder-857fe57c9cdce26057f7c158bf1c0335.jpg";